import { useRouter } from 'next/dist/client/router';
import { Dispatch, useCallback, useEffect } from 'react';
import { SingleFilter } from '../types';
import { difference } from 'lodash';
// Nina -- make these types explicit on refactoring for Feb launch
const useFilter = (
  selectedFilters: any,
  paramLabel: string,
  setSelectedFilters: Dispatch<any>,
  updatePotentialFilterForParam: (filter: SingleFilter) => void,
) => {
  const router = useRouter();
  // Clears the selection for the user
  const clearSelectedFilters = () => {
    setSelectedFilters([]); // just sets selected filters as an empty array
  };

  // Initialized the filters based on query params
  // When the router loads the first time,
  // check the query and set selected filters based on data
  useEffect(() => {

    const { query } = router;
    delete query[':region'];
    const filters = query[paramLabel] as string;

    // We store the values in the array by separating each value with an
    // underscore _
    // but selectedFilters needs to be an array
    // so we split the value and pass it in
    setSelectedFilters(filters?.split('_')?.length ? filters?.split('_') : []);
  }, [router.query]);

  // Update potential filters based on selection
  useEffect(() => {
    // Join the values to put in the form that we want to use
    // in the url
    const value = selectedFilters?.join('_');
    updatePotentialFilterForParam({ paramLabel, value });
  }, [selectedFilters]);

  const onChange = useCallback(
    (selected: string[]) => {
      if (paramLabel == 'distance') {
        const lastSelected = difference(selected, selectedFilters);
        setSelectedFilters(lastSelected);
      } else {
        setSelectedFilters(selected);
      }
    },
    [selectedFilters],
  );

  return { clearSelectedFilters, onChange };
};

export default useFilter;
